var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 offset-md-4 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-fill",
              attrs: { type: "submit" },
              on: { click: _vm.editGroup }
            },
            [_vm._v("Edit Group")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.group
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("table", { staticClass: "table table-bordered table-light" }, [
              _c("tr", [
                _c("th", [_vm._v("Id")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.group.groupDefinitionId))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Title")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.group.groupTitle))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Description")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.group.groupDescription))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Group Interests")]),
                _vm._v(" "),
                _vm.group.selectAllInterest !== 1
                  ? _c("td", [_vm._v(_vm._s(_vm.group.csvGroupIntetests))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.group.selectAllInterest === 1
                  ? _c("td", [_vm._v("Select All")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Group Tags")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.group.csvGroupVideoTagsId))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Group Experts")]),
                _vm._v(" "),
                _vm.group.selectAllExpert !== 1
                  ? _c("td", [_vm._v(_vm._s(_vm.group.csvGroupExpertsName))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.group.selectAllExpert === 1
                  ? _c("td", [_vm._v("Select All")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Group Trending Playlists")]),
                _vm._v(" "),
                _vm.group.selectAllTrendPlaylist !== 1
                  ? _c("td", [
                      _vm._v(_vm._s(_vm.group.csvGroupTrendPlaylistTitle))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.group.selectAllTrendPlaylist === 1
                  ? _c("td", [_vm._v("Select All")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Group TONE Articles")]),
                _vm._v(" "),
                _vm.group.selectAllArticle !== 1
                  ? _c("td", [
                      _vm._v(_vm._s(_vm.group.csvGroupArticlesHeading))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.group.selectAllArticle === 1
                  ? _c("td", [_vm._v("Select All")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Header Color")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.group.headerColor))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Footer Color")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.group.footerColor))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Button Color")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.group.buttonColor))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Heading Color")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.group.headingColor))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Min Limit for Work Menu")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.group.minVidReqdWork))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Min Limit for Life Menu")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.group.minVidReqdLife))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Min Limit for Mindbody Menu")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.group.minVidReqdMindBody))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Min Limit for Money Menu")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.group.minVidReqdMoney))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Status")]),
                _vm._v(" "),
                _vm.group.active == "0"
                  ? _c("td", [_vm._v("Inactive")])
                  : _c("td", [_vm._v("Active")])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Group Details")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58a77722", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58a77722","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Groups/GroupDetails.vue
// module id = 1Q2Z
// module chunks = 0